module.exports = "pegasus_template/assets/themecapture1/webinar/100.png";